/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// division
import Division from 'material/structure/division/division';
// page
import Page from 'material/structure/page/page';
// group
import Group from 'material/group/group';
// structure
import Header from 'material/structure/header/header_container';
import Body from 'material/structure/body/body_container';
import Footer from 'material/structure/footer/footer_container';
import Subhead from 'material/structure/subhead/subhead';
import Content from 'material/structure/content/content';
// charts
import LineChart from 'material/chart/linechart/linechart_container';
import data from 'material/chart/linechart/linechart_data'; // this will eventually be returned as a BE call
// copy
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
// ctas
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
import Upload from 'material/ctas/upload/upload_container';
import Link from 'material/ctas/link/link_container';
// fields
import Form from 'material/form/form_container';
import List from 'material/list/list';
import Field from 'material/form/field/field_container';
import SortableList from 'material/sortablelist/sortablelist';
// grids
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
// graphics
import Logo from 'material/graphic/logo/logo';
import Icon from 'material/graphic/icon/icon';
import Illustration from 'material/graphic/illustration/illustration';
import Photo from 'material/graphic/photo/photo';
import Divider from 'material/graphic/divider/divider';
// messages
import ToolTip from 'material/message/tooltip/tooltip';
import Tip from 'material/message/tip/tip';
import OnInActivityMessage from 'material/message/popup/inactive/inactive';
import PopupMessage from 'material/message/popup/popup';

// toggle
import Toggle from 'material/toggle/toggle';
// dropdown
import DropFilter from 'material/dropdowns/dropfilter/dropfilter';
import SearchableDropDown from 'material/dropdowns/searchabledropdown/searchabledropdown';
import DateRangePickerDropDown from 'material/dropdowns/daterangepickerdropdown/daterangepickerdropdown';
import Daypickerdropdown from 'material/dropdowns/daypickerdropdown/daypickerdropdown';
//controls
import Controls from 'material/controls/controls';
import Control from 'material/controls/control/control';
// tables
import Table from 'material/table/table';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/uikit/uikit_styles';
import FancyRadioField from 'material/fancyradio/fancyradio';

/* ========== ~~~~~~~~~~ PAGE : UI KIT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class UIKitPage extends Component {
    constructor(props){
        super(props);
        this.state={
            controlSelected:`market_research`,
            tableType: 'fixed-header',
            sites: [{name: 'insticator.com', value: 'lkdmlkmklm3'}, {name: 'worldstar.com', value: 'lkmcl2'} ],
            selectedSites: [],
            countries: [{name:'USA', value: 'aa'}],
            selectedCountries: [],
            devices: [{name:'Desktop', value: 'desktop '}, {name:'Mobile', value: 'mobile'}],
            selectedDevices: [],
            selectedDay: new Date()
        }
    }

    handleControl = (controlValue)=>{
        this.setState({controlSelected: controlValue})
    };

    showTopToaster = () => this.props.displayMessage({
        type: 'toaster',
        close: true,
        variant: 'primary',
        time: null,
        align: 'top-left',
        message: <p>Top toaster with close button</p>,
        handleClick: () => console.log('Action')
    });
    showBottomToaster = () => this.props.displayMessage({
        type: 'toaster',
        close: false,
        variant: 'primary',
        time: null,
        align: 'bottom-right',
        message: <p>Bottom toaster without close button</p>,
        handleClick: () => console.log('Action')
    });
    showTopNotification = () => this.props.displayMessage({
        type: 'notification',
        close: false,
        variant: 'attention',
        time: null,
        align: 'top-left',
        icon: 'bullhorn',
        title: 'Urgent',
        text: 'Vlads Message',
        handleClick: null
    });
    showBottomNotification = () => this.props.displayMessage({
        type: 'notification',
        close: false,
        variant: 'secondary',
        time: null,
        align: 'bottom-right',
        icon: 'bullhorn',
        title: 'Urgent',
        text: 'Bottom Notification',
        handleClick: null
    });

    render() {
        return(
            <Division name={`uikit`}>
                <Header />
                <Body>
                    <Page name={`uikit`} klass={this.props.classes.uikit}>
                        <Subhead>
                            <h1>UI Kit</h1>
                        </Subhead>
                        <Content>
                            <h1>Charts</h1>
                            <Group type={`charts`} variant={`none`} direction={`vertical`}>
                                <h2>Line Charts</h2>
                                <Group type={`smallcharts`} variant={`none`} direction={`vertical`}>
                                    <h3>Overview</h3>
                                    <LineChart variant={`overview`} data={data} />
                                    <h3>Detail</h3>
                                    {/*<LineChart variant={`detail`} data={data} />*/}
                                </Group>
                            </Group>


                            <h1>Typography</h1>
                            <Copy>
                                <Title size={`xlarge`}>
                                    <h2>Title</h2>
                                </Title>
                                <BodyCopy size={`small`}>
                                    <p>This is some sample body copy text in paragraph format.</p>
                                    <ul>
                                        <li>list item 1</li>
                                        <li>list item 2</li>
                                        <li>list item 3</li>
                                    </ul>
                                </BodyCopy>
                            </Copy>


                            <h1>Forms</h1>
                            <Group type={`fields`} variant={`none`}>
                                <Form name={`sampleForm`}>
                                    <Grid type={`fields`} direction={`horizontal`}>
                                        <GridSet direction={`horizontal`}>
                                            <GridItem>
                                                <Field type={`select`} name={`type`} placeholder={``} label={`State`} info={``} defaultValue={`other`} options={[
                                                    { name:'ny', value:'ny', text:'New York' },
                                                    { name:'other', value:'other', text:'Other' },
                                                ]} />
                                            </GridItem>
                                            <GridItem>
                                                <Field type={`number`} name={`zip`} placeholder={`10018`} label={`Zip`} info={`Must input numbers only`} />
                                            </GridItem>
                                        </GridSet>
                                        <GridSet direction={`vertical`}>
                                            <GridItem>
                                            <List type='radio' selected={['FIRST', 'SECOND',]} disabled = {'THIRD'} items={[{value: 'FIRST', text: 'first option'},
                                        {value: 'SECOND', text: 'second option'}, {value: 'THIRD', text: 'disabled option'}]} handleChange={(value) => console.log(value)}/>
                                            </GridItem>
                                            <GridItem>
                                                <Field type={`text`} name={`address`} placeholder={`200 Morris Pesin Dr`} label={`Address`} info={``} defaultValue={`123 Testing This Out`} />
                                            </GridItem>
                                            <GridItem>
                                                <Field type={`textarea`} name={`notes`} placeholder={`Give some more details ...`} label={`Notes`} info={``} />
                                            </GridItem>
                                        </GridSet>
                                        <Field type={`checkbox`} name={`rememberme`} label={`Remember Me`} handleChange={() => console.log('I was changed')} />
                                        <GridSet direction={`vertical`}>
                                            <FancyRadioField title="Test 1" name={'testfancy'} handleChange={() => console.log('I was clicked fancy 1')} />
                                            <FancyRadioField title="Test 2" name={'testfancy'} handleChange={() => console.log('I was clicked fancy 2')} />
                                            <FancyRadioField title="Test 3" name={'testfancy'} handleChange={() => console.log('I was clicked fancy 3')} />
                                            <FancyRadioField title="Test 4" name={'testfancy'} handleChange={() => console.log('I was clicked fancy 4')} />
                                            <FancyRadioField title="Test 5" name={'testfancy'} handleChange={() => console.log('I was clicked fancy 5')} />
                                            <FancyRadioField title="Test 6" name={'testfancy'} handleChange={() => console.log('I was clicked fancy 6')} />
                                            <SortableList selected={[]} disabled = {['THIRD']} items={[{value: 'FIRST', text: 'Date'},
                                        {value: 'SECOND', text: 'Site'}, {value: 'THIRD', text: 'Device'}]} handleChange={(value) => console.log(value)}></SortableList>
                                        </GridSet>
                                    </Grid>
                                </Form>
                            </Group>


                            <h1>CTAs</h1>
                            <Group type={`ctas`}>
                                <h2>Buttons</h2>
                                <CTAs type={`buttons`}>
                                    <Button type={`external`} variant={`primary`} name={`gotoinsticator`} text={`External Link`} action={`https://insticator.com`} icon={<Icon name={`external-link-alt`} />} />
                                    <Button type={`custom`} handleClick={(e) => alert('Custom click handler triggers this message')} variant={`secondary`} name={`save`} text={`Click Handler`} icon={<Icon name={`hand-pointer`} />} iconRight />
                                    <Button type={`custom`} handleClick={(e) => alert('Custom click handler triggers this message')} variant={`system`} name={`save`} text={`Click Handler`} icon={<Icon name={`hand-pointer`} />} iconRight />
                                    <Button type={`internal`} variant={`normal`} name={`homepage`} text={`Internal Route`} action={`dashboard/home`} />
                                    <Button type={'action'} action={() => alert('some redux action here')} variant={`delete`} name={`delete`} text={`Redux Action`} />
                                    <Button type={`modal`} action={<Button type={`modal`} action={false} variant={`action`} name={`closemodal`} text={`Close This Modal`} />} variant={`action`} name={`modal`} text={`Modal`} />
                                    <Button handleClick={(e) => console.log(e)} variant={`disabled`} name={`preview`} text={`Disabled`} />

                                </CTAs>
                                <h2>Links</h2>
                                <CTAs type={`links`}>
                                    <Link type={`external`} text={`External Link`} color={`secondary`} action={`http://insticator.com`} icon={<Icon name={`external-link-alt`} />} divider />
                                    <Link type={`custom`} text={`Click Handler`} color={`compliment`} handleClick={(e) => alert('Custom click handler triggers this message')} icon={<Icon name={`hand-pointer`} />} iconRight divider />
                                    <Link type={`internal`} text={`Internal Route`} color={`accent`} action={`dashboard/home`} divider />
                                    <Link type={`action`} text={`Redux Action`} color={`primary`} action={() => alert('some redux action here')} divider />
                                    <Link type={`modal`} color={`neutral`} action={<Button type={`modal`} action={false} variant={`action`} name={`closemodal`} text={`Close This Modal`} />} variant={`action`} name={`modal`} text={`Modal`} />
                                </CTAs>
                                <h2>Upload</h2>
                                <CTAs>
                                    <Upload handleDiscard={()=>console.log('descarded')} handleFileUpload={(e)=>console.log(e.target.files)}/>
                                    <Upload handleDiscard={()=>console.log('descarded')} handleFileUpload={(e)=>console.log(e.target.files)} disabled={true}/>
                                    <Upload handleDiscard={()=>console.log('descarded')} handleFileUpload={(e)=>console.log(e.target.files)} disabled={true} uploadDate={`12/12/1992`} fileName={`w9form.pdf`}/>
                                </CTAs>
                            </Group>


                        <h1>Filters</h1>
                        <Group name={``} variant={`none`} direction={`horizontal`}>
                            <DropFilter name={'sites'} title={'All Sites'} icon={`link`} button={'true'} onSelect={(items)=>this.setState({selectedSites: items})} buttonAction={items=>console.log(items)} selectedItems={this.state.selectedSites} items={this.state.sites}/>
                            <DropFilter name={'devices'} title={'All Devices'} icon={`mobile-alt`} button={'true'} onSelect={(items)=>this.setState({selectedDevices: items})} buttonAction={items=>console.log(items)} selectedItems={this.state.selectedDevices} items={this.state.devices}/>
                            <DropFilter name={'countries'} title={'All Countries'} icon={`globe`} button={'true'} onSelect={(items)=>this.setState({selectedCountries: items})} buttonAction={items=>console.log(items)} selectedItems={this.state.selectedCountries} items={this.state.countries}/>
                            <SearchableDropDown  handleSelect={(item)=>alert(item)}   name ={`all sites`} items={[{name: 'insticator.com', value: 'insticatorsiteUUID'}]} />
                            <DateRangePickerDropDown />
                        </Group>
                            <Group>
                                <Daypickerdropdown selectedDay={this.state.selectedDay} disabledDates={[{before: new Date()}]} selectDay={day=>this.setState({selectedDay: day})}/>
                            </Group>


                            <h1>Toggles</h1>
                            <Group name={`toggles`} variant={`none`} direction={`vertical`}>
                                <h2>Switches</h2>
                                <Group type={`logos`} direction={`horizontal`}>
                                    <Toggle handleClick={(e)=>console.log(e)} value={'primary'} type={'switch'} variant={'primary'} />
                                    <Toggle handleClick={(e)=>console.log(e)} value={'secondary'} type={'switch'} variant={'secondary'} />
                                </Group>
                                <h2>Checkboxes</h2>
                                <Group type={`logos`} direction={`horizontal`}>
                                    <Toggle handleClick={(e)=>console.log(e)} type={'checkbox'} color={'primary'} />
                                    <Toggle handleClick={(e)=>console.log(e)} type={'checkbox'} color={'supporting'} />
                                    <Toggle handleClick={(e)=>console.log(e)} type={'checkbox'} color={'accent'} />
                                </Group>
                            </Group>

                            <h1>Messages</h1>
                            <Group name={`messages`} variant={`none`} direction={`vertical`}>
                                <h2>Toasters</h2>
                                <Group name={`toasters`}>
                                    <Link color={`primary`} type={`action`} name={`display-toaster`} text={`Click to display Top Toaster`} action={this.showTopToaster} />
                                    <br/>
                                    <Link color={`primary`} type={`action`} name={`display-toaster`} text={`Click to display Bottom Toaster`} action={this.showBottomToaster} />
                                    <br /><br />
                                </Group>
                                <h2>Notifications</h2>
                                <Group name={`notifications`}>
                                    <Link color={`attention`}
                                          type={`modal`}
                                          name={`warning-modal`}
                                          text={`Warning Modal`}
                                          action={<PopupMessage
                                                buttonPrimary={{ text: 'Lets go home', variant: 'primary', action: () => this.props.moveToPage('dashboard/home') }}
                                                buttonSecondary={{ text: 'Lets Stay!', variant: 'system', action: () => alert('secondary Action') }}
                                                body={<p>This Modal will route you home or fire an alert. <strong>It takes in Body, Title, button text, and actions</strong>. Do you want to be routed to the <strong>Home Page?</strong></p>}
                                                title={'Do Something'}
                                                type={'warning'} />}
                                    />
                                    <Link color={`primary`} type={`action`} name={`display-notification`} text={`Click to display Top Notification`} action={this.showTopNotification} />
                                    <br />
                                    <Link color={`primary`} type={`action`} name={`display-notification`} text={`Click to display Bottom Notification`} action={this.showBottomNotification} />
                                    <br />
                                    <Link color={`secondary`}
                                          type={`modal`}
                                          name={`extendsession-modal`}
                                          text={`Session Extension Modal`}
                                          action={<OnInActivityMessage primaryAction={() => alert('Oh you are still here!!')} />}
                                    />
                                    <br /><br />
                                    {/*<Notification title={`Yo`} text={`This is an alert in Primary`} icon={`exclamation-triangle`} variant={`attention`} />*/}
                                    {/*<Notification title={`Heyyyy`} text={`This is an alert in Primary`} icon={`bullhorn`} variant={`primary`} />*/}
                                    {/*<Notification title={`Hello`} text={`This is an alert in Primary`} icon={`check-circle`} variant={`secondary`} />*/}
                                </Group>
                                <h2>ToolTips</h2>
                                <Group name={`tooltips`}>
                                    <Tip content={<p>Further explanation happens here</p>} space={`around`} />
                                    <br />
                                    <ToolTip align={`right`} action={`click`} content={<p>Further explanation happens here</p>}><Icon name={`exclamation-circle`} /></ToolTip>
                                    <br />
                                    <ToolTip position={`top`} action={`mouseenter`} content={<p>Further explanation happens here</p>}><p>Hover over me to see this work on any element not just icons</p></ToolTip>
                                    <br />
                                    <ToolTip align={`down`} action={`open`} content={<p>Further explanation happens here</p>}><p>Here's how I look when visible immediately</p></ToolTip>
                                </Group>

                            </Group>


                            <h1>Graphics</h1>
                            <Group type={`visuals`} variant={`none`} direction={`vertical`}>
                                <h2>Logos</h2>
                                <Group type={`logos`} direction={`horizontal`}>
                                    <Logo name={`insticator`} text={`Insticator`} />
                                    <Logo name={`insticator-icon`} text={`Insticator Icon`} />
                                </Group>
                                <h2>Icons</h2>
                                <Group type={`icons`} variant={`none`}>
                                    <Icon name={`chart-line`} />
                                    <Icon name={`users`} color={`primary`} space={`right`} />
                                    <Icon name={`align-left`} space={`both`} />
                                    <Icon name={`bolt`} />
                                    <Icon name={`puzzle-piece`} />
                                    <Icon name={`chart-pie`} />
                                </Group>
                                <h2>Illustrations</h2>
                                <Group type={`illustrations`} variant={`none`}>
                                    <Illustration name={`placeholder`} text={`Placeholder`} />
                                </Group>
                                <h2>Divider</h2>
                                <Group type={`dividers`} variant={`none`}>
                                    <Divider name={`placeholder`} color={`primary`} />
                                </Group>
                                <h2>Photos</h2>
                                <Group type={`photos`} variant={`none`}>
                                    <Photo name={`placeholder`} text={`Placeholder`} />
                                </Group>
                            </Group>


                            <h1>Controls</h1>
                            <Group type={`controls`} >
                                <Controls>
                                    <Control selected={this.state.controlSelected} text={`Ads Revenue`} value={`ads_revenue`} handleSelect={this.handleControl} />
                                    <Control selected={this.state.controlSelected} text={`Market Research`} value={`market_research`} handleSelect={this.handleControl} />
                                    <Control selected={this.state.controlSelected} text={`Compare`} value={`compare`} handleSelect={this.handleControl} />
                                </Controls>
                            </Group>


                            <h1>Tables</h1>
                            <Group type={`tables`} >
                                <h2>Table Functionality</h2>
                                <p>This table is built by passing through data as props. The table component will automatically generate the appropriate markup based on the data set.</p>
                                <br />
                                <p>You can order and remove data via the "columnHeads" prop. The data in the table will respect this object you pass through and display its data based on that format.</p>
                                <br />
                                <Link type={`custom`} text={`fixed-column`} color={`accent`} handleClick={(e) => this.setState({ tableType: 'fixed-column' })} divider />
                                <Link type={`custom`} text={`basic`} color={`secondary`} handleClick={(e) => this.setState({ tableType: 'basic' })} />
                                <br /><br /><br />

                                <Table 
                                    name={`standardtable`}
                                    type={this.state.tableType} 
                                    columnHeads={{ name: 'Name', gender: 'Gender', age: 'Age', size: 'Size', phone: 'Phone'}}
                                    data={[
                                        { size: ["L", "M"], phone: 1234567, gender: "Male", age: 20, name:"Ben" },
                                        { size: ["L", "M", "XL"], phone: 1234567, gender: "Female", age: 22, name:"Ken" },
                                        { size: ["L", "S"], phone: 1234567, gender: "Female", age: 23, name:"Jay" },
                                        { size: ["M", "S"], phone: 1234567, gender: "Male", age: 26, name:"Chip" },
                                        { size: ["XL", "XS"], phone: 1234567, gender: "Male", age: 23, name:"Lee" },
                                        { size: ["L", "M", "S", "XS"], phone: 1234567, gender: "Female", age: 30, name:"Frank" },
                                        { size: ["S", "L"], phone: 1234567, gender: "Male", age: 23, name:"CoCo" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 20, name:"Fake" },
                                        { size: ["XS", "L"], phone: 1234567, gender: "Male", age: 26, name:"Dump" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 27, name:"Ocean" },
                                        { size: ["S", "XL"], phone: 1234567, gender: "Male", age: 20, name:"Polo" },
                                        { size: ["M", "XL"], phone: 1234567, gender: "Female", age: 21, name:"Queen" },
                                        { size: ["L", "M"], phone: 1234567, gender: "Female", age: 20, name:"Bump" },
                                        { size: ["L", "M", "S", "XL"], phone: 1234567, gender: "Male", age: 22, name:"Judy" },
                                        { size: ["XL", "M"], phone: 1234567, gender: "Female", age: 24, name:"Ryan" },
                                        { size: ["L", "S"], phone: 1234567, gender: "Female", age: 25, name:"Flow" },
                                        { size: ["S", "M"], phone: 1234567, gender: "Female", age: 31, name:"Ray" },
                                        { size: ["L", "M", "XS"], phone: 1234567, gender: "Male", age: 23, name:"Yen" },
                                        { size: ["XL", "M", "S"], phone: 1234567, gender: "Male", age: 21, name:"Gray" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 22, name:"Tom" }
                                    ]}
                                    rowsPerPage={null}
                                />

                                <br /><br />

                                <h2>Paginated Table</h2>
                                 <Table 
                                    name={`paginatedtable`}
                                    type={'basic'} 
                                    size={`full`}
                                    columnHeads={{ name: 'Name', gender: 'Gender', age: 'Age', size: 'Size', phone: 'Phone'}}
                                    data={[
                                        { size: ["L", "M"], phone: 1234567, gender: "Male", age: 20, name:"Ben" },
                                        { size: ["L", "M", "XL"], phone: 1234567, gender: "Female", age: 22, name:"Ken" },
                                        { size: ["L", "S"], phone: 1234567, gender: "Female", age: 23, name:"Jay" },
                                        { size: ["M", "S"], phone: 1234567, gender: "Male", age: 26, name:"Chip" },
                                        { size: ["XL", "XS"], phone: 1234567, gender: "Male", age: 23, name:"Lee" },
                                        { size: ["L", "M", "S", "XS"], phone: 1234567, gender: "Female", age: 30, name:"Frank" },
                                        { size: ["S", "L"], phone: 1234567, gender: "Male", age: 23, name:"CoCo" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 20, name:"Fake" },
                                        { size: ["XS", "L"], phone: 1234567, gender: "Male", age: 26, name:"Dump" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 27, name:"Ocean" },
                                        { size: ["S", "XL"], phone: 1234567, gender: "Male", age: 20, name:"Polo" },
                                        { size: ["M", "XL"], phone: 1234567, gender: "Female", age: 21, name:"Queen" },
                                        { size: ["L", "M"], phone: 1234567, gender: "Female", age: 20, name:"Bump" },
                                        { size: ["L", "M", "S", "XL"], phone: 1234567, gender: "Male", age: 22, name:"Judy" },
                                        { size: ["XL", "M"], phone: 1234567, gender: "Female", age: 24, name:"Ryan" },
                                        { size: ["L", "S"], phone: 1234567, gender: "Female", age: 25, name:"Flow" },
                                        { size: ["S", "M"], phone: 1234567, gender: "Female", age: 31, name:"Ray" },
                                        { size: ["L", "M", "XS"], phone: 1234567, gender: "Male", age: 23, name:"Yen" },
                                        { size: ["XL", "M", "S"], phone: 1234567, gender: "Male", age: 21, name:"Gray" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 22, name:"Tom" }
                                    ]}
                                    showTitle={true}
                                    exportData={true}
                                    paginationLocation={`bottom`}
                                    rowsPerPage={5}
                                    moreDetails={true}
                                />

                                <h2>Special Header and Rows</h2>
                                <Table 
                                    name={`specialheadandrowsandmessage`}
                                    vavriant={`slim`}
                                    type={'basic'} 
                                    size={`full`}
                                    specialHeads={[{ colspan: 3, colcontent: `Dimensions` }, { colspan: 2, colcontent: `Metrics` }]}
                                    columnHeads={{ name: 'Name', gender: 'Gender', age: 'Age', size: 'Size', phone: 'Phone'}}
                                    specialRow={[{ colspan: 3, colcontent: `Colspaned Row` }, { colspan: null, colcontent: { age: 20, name:"Ben" } }]}
                                    specialRowPosition={`top`}
                                    data={[
                                        { size: ["L", "M"], phone: 1234567, gender: "Male", age: 20, name:"Ben" },
                                        { size: ["L", "M", "XL"], phone: 1234567, gender: "Female", age: 22, name:"Ken" },
                                        { size: ["L", "S"], phone: 1234567, gender: "Female", age: 23, name:"Jay" },
                                        { size: ["M", "S"], phone: 1234567, gender: "Male", age: 26, name:"Chip" },
                                        { size: ["XL", "XS"], phone: 1234567, gender: "Male", age: 23, name:"Lee" },
                                        { size: ["L", "M", "S", "XS"], phone: 1234567, gender: "Female", age: 30, name:"Frank" },
                                        { size: ["S", "L"], phone: 1234567, gender: "Male", age: 23, name:"CoCo" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 20, name:"Fake" },
                                        { size: ["XS", "L"], phone: 1234567, gender: "Male", age: 26, name:"Dump" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 27, name:"Ocean" },
                                        { size: ["S", "XL"], phone: 1234567, gender: "Male", age: 20, name:"Polo" },
                                        { size: ["M", "XL"], phone: 1234567, gender: "Female", age: 21, name:"Queen" },
                                        { size: ["L", "M"], phone: 1234567, gender: "Female", age: 20, name:"Bump" },
                                        { size: ["L", "M", "S", "XL"], phone: 1234567, gender: "Male", age: 22, name:"Judy" },
                                        { size: ["XL", "M"], phone: 1234567, gender: "Female", age: 24, name:"Ryan" },
                                        { size: ["L", "S"], phone: 1234567, gender: "Female", age: 25, name:"Flow" },
                                        { size: ["S", "M"], phone: 1234567, gender: "Female", age: 31, name:"Ray" },
                                        { size: ["L", "M", "XS"], phone: 1234567, gender: "Male", age: 23, name:"Yen" },
                                        { size: ["XL", "M", "S"], phone: 1234567, gender: "Male", age: 21, name:"Gray" },
                                        { size: ["L", "M", "S"], phone: 1234567, gender: "Female", age: 22, name:"Tom" }
                                    ]}
                                    message={`Previewing only the first 100 rows. Download the report for full access.`}
                                    showTitle={true}
                                    exportData={true}
                                    paginationLocation={`bottom`}
                                    rowsPerPage={5}
                                    moreDetails={true}
                                />

                            </Group>
                        </Content>
                    </Page>
                </Body>
                <Footer />
            </Division>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(UIKitPage);
